export const incomingCallMappings = {
  IncomingCallTitle: {
    nb: 'Innkommende samtale',
    en: 'Incoming call',
  },
  IncomingCallQuestion: {
    nb: ' ringer til deg. Vil du bli med?',
    en: ' is calling you. Join now?',
  },
  IncomingCallAccept: {
    nb: 'Bli med',
    en: 'Join conversation',
  },
  IncomingCallDecline: {
    nb: 'Ikke nå',
    en: 'Not now',
  },
  IncomingCallInviterFallback: {
    nb: 'Noen',
    en: 'Someone',
  },
  IncomingCallConversationFallback: {
    nb: 'En samtale',
    en: 'A conversation',
  },
};
